<div class="page-container trade-review-detail-container container pt-2">
  <h1 class="header col-12 mb-1"> Transaction Details </h1>
  @if (!loading) {
    <div class="actions-container mb-3">
      <button
        type="button"
        mat-button
        color="primary"
        (click)="nav('trade-review')"
      >
        <mat-icon>arrow_back_ios</mat-icon> Back to Transaction Monitor
      </button>
    </div>

    <div class="trade-info-container info-card mb-4 w-100 p-0">
      <div class="card-header">
        <span class="card-title-container">
          <mat-icon
            class="scoreclass-icon me-2 {{ tradeDetail.ScoreClass }}"
            [matTooltip]="'Trade Score: ' + tradeDetail.ScoreClass"
            [matTooltipPosition]="'above'"
          >
            {{ scoreClassKey[tradeDetail.ScoreClass] }}
          </mat-icon>
          Trade ID: <span class="card-title mb-0 ml-2">{{ tradeId }}</span>
        </span>

        @if (!rights.includes('PostTradeReadOnly')) {
          <span>
            <app-approval-menu
              [recordStatus]="tradeDetail.ApprovalStatus"
              [recordType]="'trade'"
              (toggleStatus)="toggleApproval($event)"
            />
          </span>
        }
      </div>
      <div class="card-info row">
        @for (tradeInfo of tradeInfoKey; track tradeInfo.label) {
          @if (
            (tradeDetail && tradeDetail[tradeInfo.varName]) ||
            (tradeInfo.key && tradeInfo.key[tradeDetail[tradeInfo.varName]])
          ) {
            <app-card-infopoint
              class="col-sm-3 col-12"
              [datapoint]="tradeInfo"
              [dataset]="tradeDetail"
            />
          } @else if (
            tradeInfo.varSet &&
            tradeDetail.Details[tradeInfo.varSet] &&
            tradeDetail.Details[tradeInfo.varSet][tradeInfo.varName]
          ) {
            <app-card-infopoint
              class="col-sm-3 col-12"
              [datapoint]="tradeInfo"
              [dataset]="tradeDetail.Details"
            />
          }
        }
      </div>
    </div>

    @if (rights.includes('CM') && aiSummary) {
      <div class="info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> AI Transaction Summary </span>
        </div>
        <div class="card-info row">
          <div class="notes-list px-3" [innerHTML]="aiSummary"></div>
          <div class="ai-disclaimer px-3 pt-3 w-100">
            <span>
              **This is created by generative AI. Results and details should be
              verified.
            </span>
          </div>
        </div>
      </div>
    }

    @if (tradeDetail?.Details.bridges) {
      <div class="alerts-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Alerts </span>
        </div>
        <div class="card-info row">
          <div class="alerts w-100">
            @for (bridge of tradeDetail.Details.bridges; track bridge) {
              @if (ptSvc.bridgeHasAlerts(bridge.trueRules)) {
                <app-reason-text
                  class="col-12"
                  [data]="bridge.trueRules"
                  [defaultView]="'list'"
                  [accountLinkingStatus]="linkedAccount?.Status"
                  [linkString]="
                    '/account-linking/' + tradeDetail.Details.Trade.AccountID
                  "
                />
              } @else {
                <div class="no-data no-alerts w-100">No Alerts Found</div>
              }
            }
          </div>
        </div>
      </div>
    }

    <div class="multi-table-container">
      <app-multi-table-card
        class="{{ tradeDetail.Details.Account ? 'w-33' : 'w-50' }}"
        [title]="'Transaction Info'"
        [infoKey]="productInfoKey"
        [tradeDetail]="tradeDetail"
        [sourceDataButton]="true"
      />

      @if (tradeDetail.Details.Account) {
        <app-multi-table-card
          class="{{ tradeDetail.Details.Account ? 'w-33' : 'w-50' }}"
          [title]="'Account Info'"
          [infoKey]="accountKey"
          [tradeDetail]="tradeDetail"
          [linkedAccount]="linkedAccount"
        />
      }

      <app-multi-table-card
        class="{{ tradeDetail.Details.Account ? 'w-33' : 'w-50' }}"
        [title]="'Client Suitability Info'"
        [infoKey]="suitabilityKey"
        [tradeDetail]="tradeDetail"
      />
    </div>

    <div class="info-card mb-4">
      <div class="card-header">
        <span class="card-title mb-0"> Actions </span>
        @if (!rights.includes('PostTradeReadOnly')) {
          <span>
            <app-approval-menu
              [recordStatus]="tradeDetail.ApprovalStatus"
              [recordType]="'trade'"
              (toggleStatus)="toggleApproval($event)"
            />
          </span>
        }
      </div>
      <div class="actions-card">
        <div class="custom-tabs">
          <mat-tab-group [selectedIndex]="selectedActionTab">
            <mat-tab label="Notes & Attachments">
              <app-attachments-widget
                [tradeId]="tradeId"
                [tradeDetail]="tradeDetail"
                [readOnly]="rights.includes('PostTradeReadOnly')"
              />
            </mat-tab>

            <mat-tab label="Trade Approval History">
              <app-expanding-table
                [dataset]="tradeDetail?.TradeApprovalHistory"
                [evalKey]="tradeApprovalKey"
              />
            </mat-tab>

            @if (rights.includes('CM')) {
              <mat-tab label="Case History">
                @if (!rights.includes('PostTradeReadOnly')) {
                  <div class="mb-2 pt-2 initiate-case-container">
                    <button
                      type="button"
                      mat-raised-button
                      color="primary"
                      class="w-50"
                      [disabled]="!tradeDetail.RepCode"
                      (click)="initiateCase()"
                    >
                      <mat-icon>medical_services</mat-icon> Initiate Case
                    </button>
                  </div>
                }

                <app-expanding-table
                  [dataset]="caseHistory"
                  [evalKey]="caseHistoryKey"
                  [actionColumn]="{
                    link: 'case-management/case-manager/',
                    selector: 'CRID',
                    tooltip: 'Review Case',
                    icon: 'rate_review',
                    external: true,
                  }"
                />
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      </div>
    </div>

    @if (tradeDetail.Details.DisplayFX?.ShowConcurrentTrades) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Concurrent Trades </span>
        </div>
        <app-expanding-table
          [dataset]="tradeDetail.Details.ConcurrentTradesDisplay"
          [evalKey]="concurrentTradesKey"
          [actionColumn]="{
            link: 'trade-review/',
            selector: 'TradeID',
            tooltip: 'View Transaction',
            icon: 'launch',
            external: true,
          }"
        />
      </div>
    }

    @if (
      tradeDetail.Details.AWExchange && !isEmpty(tradeDetail.Details.AWExchange)
    ) {
      <div class="annuity-exchange-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Annuity Exchange </span>
        </div>
        @for (awExchange of tradeDetail.Details.AWExchange; track awExchange) {
          <app-basic-table
            [headers]="awExchange.header"
            [data]="awExchange.data"
          />
        }
      </div>
    }

    @if (
      (tradeDetail.Details.AccountGroup &&
        !isEmpty(tradeDetail.Details.AccountGroup)) ||
      (charts && charts['breakpoints'])
    ) {
      <div class="annuity-exchange-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Breakpoint Analysis </span>

          <span>
            @if (
              rights.includes('AccountGroup') &&
              !tradeDetail?.Details?.AccountGroup?.GroupID &&
              !rights.includes('PostTradeReadOnly')
            ) {
              <button
                type="button"
                mat-raised-button
                [matTooltip]="'Select this option to link the current account to a group of accounts for purposes of breakpoint householding. Grouped positions will be represented in future account transactions.'"
                [matTooltipPosition]="'above'"
                (click)="accountGrouping()"
              >
                <mat-icon>dataset_linked</mat-icon> Link to Account Group
              </button>
            }
          </span>
        </div>
        <div class="card-info row">
          @for (breakpoint of breakpointAnalysisKey; track breakpoint.label) {
            @if (
              tradeDetail.Details[breakpoint.varSet] &&
              tradeDetail.Details[breakpoint.varSet][breakpoint.varName]
            ) {
              <app-card-infopoint
                class="col-sm-3 col-12"
                [datapoint]="breakpoint"
                [dataset]="tradeDetail.Details"
              />
            }
          }
          @if (charts && charts['breakpoints']) {
            <app-post-trade-chart
              class="col-12"
              [chart]="charts['breakpoints']"
            />
          }
        </div>
      </div>
    }

    @if (tradeDetail.Details.DisplayFX?.ShowTradeHistory) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Transaction History </span>
        </div>
        <app-expanding-table
          [dataset]="tradeDetail.Details.TradeHistory"
          [evalKey]="tradeHistoryKey"
          [actionColumn]="{
            link: 'trade-review/',
            selector: 'TradeID',
            tooltip: 'View Transaction',
            icon: 'launch',
            external: true,
          }"
        />
      </div>
    }

    <app-holdings-card [chartDetails]="tradeDetail.Details" />

    @if (tradeDetail.Details.AnnuityPosition) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Annuity Holdings </span>
        </div>
        <app-basic-table
          [headers]="annuityPositionKey"
          [data]="tradeDetail.Details.AnnuityPosition"
        />
      </div>
    }

    @if (
      tradeDetail.Details.RightBRIDGECase &&
      !isEmpty(tradeDetail.Details.RightBRIDGECase)
    ) {
      <div class="associated-case-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Associated RightBRIDGE Case </span>
          <button
            type="button"
            class="white-text me-2"
            mat-raised-button
            color="accent"
            (click)="downloadFactSheet()"
          >
            <mat-icon>download</mat-icon> Download RightBRIDGE Report
          </button>
        </div>
        <div class="card-info row">
          @for (
            associatedCase of associatedCaseKey;
            track associatedCase.label
          ) {
            @if (tradeDetail.Details[associatedCase.varSet]) {
              <app-card-infopoint
                class="col-sm-3 col-12"
                [datapoint]="associatedCase"
                [dataset]="tradeDetail.Details"
              />
            }
          }
        </div>

        @if (productModules.length > 0) {
          <div class="card-info">
            <div class="row top-border">
              <div class="card-info-label col-12">
                Product Recommendations
              </div>
              @for (productModule of productModules; track productModule) {
                <div class="product-recommendation-container col-sm-6 col-12">
                  <div class="product-recommendation-module mb-3">
                    <div class="card-info-value recommendation-header">
                      {{ productModulesKey[productModule] }}
                    </div>

                    <div class="products-container">
                      @for (
                        product of productRecommendations[productModule];
                        track product.BridgeID
                      ) {
                        <div class="product-recommendation">
                          <mat-icon class="me-1" [ngClass]="product.ScoreClass">
                            circle
                          </mat-icon>
                          {{ product.Name }} &mdash; {{ product.Amount }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        @if (tradeDetail?.Details?.ClientProfiling?.Notes) {
          <div class="card-info">
            <div class="row top-border">
              <div class="card-info-label col-12"> Notes </div>
              <div class="card-info-value col-12">
                {{ tradeDetail.Details.ClientProfiling.Notes }}
              </div>
            </div>
          </div>
        }
      </div>
    }
  }

  <ngx-loading [show]="loading" />
</div>
